import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Star, Quote } from 'lucide-react';

export const Testimonials = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  const testimonials = [
    {
      quote:
        "I used to spend every Monday managing link-tracking spreadsheets. Searchefy cut that to 20 minutes. The DA/PA filters mean I only target quality sites now.",
      name: 'Priya S.',
      role: 'SEO Head, B2B SaaS Company',
      avatar: 'PS',
      rating: 5,
    },
    {
      quote:
        "As a founder with zero SEO background, Searchefy made link building actually doable. Built 12 backlinks in my first week — without hiring an agency.",
      name: 'Arjun M.',
      role: 'Founder, EdTech Startup',
      avatar: 'AM',
      rating: 5,
    },
    {
      quote:
        "$9 for lifetime access to 500+ vetted backlink sources plus an unlimited project tracker? I've been using it for three months and my client's domain jumped from DA 18 to 34.",
      name: 'Kavita R.',
      role: 'Freelance SEO Consultant',
      avatar: 'KR',
      rating: 5,
    },
  ];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="section-light py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-gray-900 mb-4">
            Trusted by SEO Professionals,{' '}
            <span className="gradient-text">Marketers, and Founders</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Real results from real users who transformed their link-building workflow.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="testimonial-card relative"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote icon */}
              <div className="absolute -top-4 -left-2 w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 flex items-center justify-center">
                <Quote size={18} className="text-white" />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    size={16}
                    className="fill-yellow-400 text-yellow-400"
                  />
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-700 leading-relaxed mb-6">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 flex items-center justify-center text-white font-bold">
                  {testimonial.avatar}
                </div>
                <div>
                  <p className="font-medium text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
